<div class="accession">
  <div class="accession-wrap">
    <div class="accession-content">
      <div class="accession-header">
        <h1
          [innerHTML]="'HOME.TITLE' | translate"
          class="accession-title"
        ></h1>
        <div class="accession-header-inner">
          <div>
            <h3 [innerHTML]="'HOME.RATE' | translate" class="accession-rate"></h3>
            <h3 class="accession-subtitle">
              {{ 'HOME.SUBTITLE' | translate }}
            </h3>
          </div>
        </div>
      </div>
      <div class="accession-calculate">
        <app-calculate color="white" size="big"></app-calculate>
      </div>
    </div>
  </div>
</div>
